import { FunctionComponent } from 'react';
import { FormattedError } from './FormattedError';

interface Props {
  syntaxErrors: string[];
}

const SyntaxErrors: FunctionComponent<Props> = ({ syntaxErrors }) => {
  if (syntaxErrors.length === 0) {
    return null;
  }
  return (
    <div>
      {syntaxErrors.map((error, index) => {
        return (
          <div className="text-red-300 text-xs" key={`spec-${index}`}>
            <FormattedError error={error} />
          </div>
        );
      })}
    </div>
  );
};

export default SyntaxErrors;
